/**
 * Gallery Media Utilities
 * 
 * Shared utilities for detecting and working with gallery media types.
 * Includes defensive fallback logic for when backend media_type is incorrect.
 */

const VIDEO_EXT_REGEX = /\.(mp4|mov|webm|avi|mkv|m4v|flv|wmv|3gp)$/i;

/**
 * Check if a media item is a video
 * 
 * Uses defensive detection: checks both media_type field and file extension.
 * This handles cases where backend returns media_type: 'image' for videos.
 * 
 * @param media_type - The media_type field from backend (may be incorrect)
 * @param url - The file URL/path (used for extension fallback)
 * @returns true if the item is a video
 */
export const isVideoMedia = (media_type?: string, url?: string): boolean => {
  const safeUrl = url || '';
  return media_type === 'video' || VIDEO_EXT_REGEX.test(safeUrl);
};

/**
 * Check if a media item is an image
 * 
 * @param media_type - The media_type field from backend
 * @param url - The file URL/path (used for extension fallback)
 * @returns true if the item is an image (not a video)
 */
export const isImageMedia = (media_type?: string, url?: string): boolean => {
  return !isVideoMedia(media_type, url);
};
